import { z } from 'zod';

export const GlossaryTermIdSchema = z.string().regex(/^glossary\.[a-z0-9-]+$/);

export type GlossaryTermId = z.infer<typeof GlossaryTermIdSchema>;

/** Full glossary entry contract — Section 5.11 implementation plan. */
export const GlossaryEntrySchema = z.object({
  termId: GlossaryTermIdSchema,
  slug: z.string().regex(/^[a-z0-9-]+$/),
  term: z.string().min(2),
  aliases: z.array(z.string()).default([]),
  category: z.string(),
  oneSentence: z.string().min(20),
  fullExplanationMdx: z.string().min(160).refine(
    (value) => value.includes('\n\n'),
    'fullExplanationMdx must contain multiple paragraphs',
  ),
  whyItMatters: z.string().min(20),
  howItIsCalculatedOrDerived: z.string().optional(),
  howToReadIt: z.string().min(20),
  highLowOrStateInterpretation: z.string().optional(),
  cscStructuralLens: z.string().min(20),
  workedExample: z.string().optional(),
  commonMisreadings: z.array(z.string()).min(1),
  limitationsAndFalsifiers: z.array(z.string()).min(1),
  relatedTermIds: z.array(GlossaryTermIdSchema).default([]),
  usedOnRoutes: z.array(z.string()).default([]),
  sourceIds: z.array(z.string()).min(1),
  reviewedAt: z.string().datetime(),
  version: z.string().min(1),
});

export type GlossaryEntry = z.infer<typeof GlossaryEntrySchema>;

export const GuidedLessonSchema = z.object({
  lessonId: z.string(),
  slug: z.string(),
  title: z.string(),
  description: z.string(),
  steps: z
    .array(
      z.object({
        stepId: z.string(),
        title: z.string(),
        content: z.string(),
        glossaryTermIds: z.array(GlossaryTermIdSchema).default([]),
      }),
    )
    .min(1),
  routeTargets: z.array(z.string()).default([]),
});

export type GuidedLesson = z.infer<typeof GuidedLessonSchema>;
